// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://ngagtienwooguwquvtbn.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5nYWd0aWVud29vZ3V3cXV2dGJuIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI5Nzg5MDEsImV4cCI6MjA2ODU1NDkwMX0.SemTUlcrkgdevxKKAYvobk3hf7j5K7rF1dH-fdxhCCA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});